import { render, staticRenderFns } from "./Idea.vue?vue&type=template&id=73724746&scoped=true&"
import script from "./Idea.vue?vue&type=script&lang=js&"
export * from "./Idea.vue?vue&type=script&lang=js&"
import style0 from "./Idea.vue?vue&type=style&index=0&id=73724746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73724746",
  null
  
)

export default component.exports